<template>
  <div class="box">
    <div class="wscn-http404">
      <div class="pic-404">
        <img class="pic-404__parent" :src="img_404" alt="404">
        <img class="pic-404__child left" :src="img_404_cloud" alt="404">
      </div>
      <div class="bullshit">
        <div class="bullshit__headline">{{ message }}</div>
        <div class="bullshit__info">请检查您输入的网址是否正确，请点击以下按钮返回主页或者发送错误报告</div>
        <a href="/" class="bullshit__return-home">返回首页</a>
      </div>
    </div>
  </div>
</template>

<script>
import img_404 from '@/assets/404_images/404.png'
import img_404_cloud from '@/assets/404_images/404_cloud.png'

export default {
  name: 'page404',
  data() {
    return {
      img_404,
      img_404_cloud
    }
  },
  computed: {
    message() {
      return '页面不存在......'
    }
  }
}
</script>

<style type="text/scss" scoped>
*{
  margin: 0;
  padding: 0;
  background: #f0f2f5;
}
.box{
  height: 100vh;
  background: #f0f2f5;
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex: 1;
}
.wscn-http404 {
  width: 1200px;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
/* 左边部分 */
.pic-404{
  width: 600px;
  height: 100vh;
  position: relative;
  padding: 150px 0;
  overflow: hidden;
  box-sizing: border-box;
}
.pic-404__parent {
  width: 600px;
  height: 320px;
  position: absolute;
  right: 0;
}
/* 云 动画 */
.left {
  width: 80px;
  top: 17px;
  left: 220px;
  opacity: 0;
  animation-name: cloudLeft;
  animation-duration: 3s;  /* 过程持续 3s */
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  animation-delay: 1s;  /* 1s 后开始 */
}

/* 右边部分 */
.bullshit{
  width: 400px;
  position: relative;
  padding: 150px 0;
  overflow: hidden;
  box-sizing: border-box;
}
.bullshit__headline {
  color: #1482f0;
  font-size: 20px;
  animation-name: slideUp;
  animation-duration: 0.5s;
  animation-delay: 0.1s;
  animation-fill-mode: forwards;
}
.bullshit__info {
  color: grey;
  font-size: 14px;
  margin: 10px 0 30px 0;
  /* 动画 */
  animation-name: slideUp;
  animation-duration: 0.5s;
  animation-delay: 0.2s;
  animation-fill-mode: forwards;
}
.bullshit__return-home {
  display: block;
  width: 140px;
  height: 40px;
  line-height: 40px;
  color: #FFFFFF;
  background-color: #1482f0;
  border-radius: 30px;
  text-align: center;
  animation-name: slideUp;
  animation-duration: 0.5s;
  animation-delay: 0.3s;
  animation-fill-mode: forwards;
}
.bullshit__return-home:link {
  text-decoration: none;
}
/* 字体 动画方法 */
@keyframes slideUp {
  0% {
    transform: translateY(60px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
/* 云 动画方法 */
@keyframes cloudLeft {
  0% {
    top: 17px;
    left: 220px;
    opacity: 0;
  }
  20% {
    top: 33px;
    left: 188px;
    opacity: 1;
  }
  80% {
    top: 81px;
    left: 92px;
    opacity: 1;
  }
  100% {
    top: 97px;
    left: 60px;
    opacity: 0;
  }
}

</style>
